import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAdminOpenChat = (id) => {
  return axiosClient.post(`/api/admin/im/open/${id}`).then((r) => r.data);
};
